import type { ComputedRef, InjectionKey } from "vue";
import { computed, hasInjectionContext, inject } from "vue";
import { useAuthStore } from "../AuthStore/useAuthStore";

export const MULTILINGUAL_MODULE_KEY: InjectionKey<ComputedRef<boolean>> = Symbol("multilingualModule");

/**
 * Web gates editing content per language (the language pill on translatable fields and template texts) and the
 * language settings behind the staff-only `enableMultilingualModule` preference by providing
 * `useMultilingualModulePreference()` under `MULTILINGUAL_MODULE_KEY`. Apps that do not provide it (CMS) always
 * show them. Reading content in the user's language does not depend on it.
 */
export function useMultilingualModuleEnabled(): ComputedRef<boolean> {
  if (!hasInjectionContext()) {
    return computed(() => true);
  }
  return inject(MULTILINGUAL_MODULE_KEY, () => computed(() => true), true);
}

export function useMultilingualModulePreference(): ComputedRef<boolean> {
  const { userPreferences } = useAuthStore();
  return computed(() => userPreferences.value?.enableMultilingualModule === true);
}
